import { get, post } from "../client";
import {
  GET_WAITING_LIST_CLIENTS,
  REMOVE_FROM_WAITING_LIST,
} from "../routes";

export default {
  get_clients: async (businessId, date, serviceId) => {
    let url = `${GET_WAITING_LIST_CLIENTS(businessId)}?date=${date}`;
    if (serviceId) url += `&serviceId=${serviceId}`;
    return await get(url);
  },

  remove: async (data) => await post(REMOVE_FROM_WAITING_LIST, data),
};
